import { render, staticRenderFns } from "./LazyPhotos.vue?vue&type=template&id=792ddd16&scoped=true"
import script from "./LazyPhotos.vue?vue&type=script&lang=js"
export * from "./LazyPhotos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792ddd16",
  null
  
)

export default component.exports